import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const TaskWorkflowSyncMappings = lazyWithRetry(
  () => import("./TaskWorkflowSyncMappings")
);

export default () => (
  <Page>
    <TaskWorkflowSyncMappings />
  </Page>
);
